import { render, staticRenderFns } from "./Commission Area.vue?vue&type=template&id=342bde06"
import script from "./Commission Area.vue?vue&type=script&lang=js"
export * from "./Commission Area.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports